// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

const ScoreboardBasePage = () => import('@/modules/scoreboard/views/ScoreboardBasePage')

const OpenerScoreboardPage = () => import('@/modules/scoreboard/views/OpenerScoreboardPage')
const SalesScoreboardPage = () => import('@/modules/scoreboard/views/SalesScoreboardPage')
const OperationScoreboardPage = () => import('@/modules/scoreboard/views/OperationScoreboardPage')
const OpenerScoreboardTransferPage = () => import('@/modules/scoreboard/views/OpenerScoreboardTransferPage')
const ScoreboardLoopPlayer = () => import('@/modules/scoreboard/views/ScoreboardLoopPlayer')


var routes = [
	{
		path: '/scoreboard/base',
		redirect: '/scoreboard/base',
		component: DefaultContainer,
		children: [
			{
				path: '/scoreboard/base',
				name: 'ScoreboardBasePage',
				component: ScoreboardBasePage,
				meta: {
					requiresAuth: true,
				},
			},
		]
	},
	{
		path: '/scoreboard/opener/company/:companyId',
		name: 'OpenerScoreboardPage',
		component: OpenerScoreboardPage,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/scoreboard/sales/company/:companyId',
		name: 'SalesScoreboardPage',
		component: SalesScoreboardPage,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/scoreboard/operations',
		name: 'OperationScoreboardPage',
		component: OperationScoreboardPage,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/scoreboard/opener-transfer/company/:companyId',
		name: 'OpenerScoreboardTransferPage',
		component: OpenerScoreboardTransferPage,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/scoreboard/loop/:loopId',
		name: 'ScoreboardLoopPlayer',
		component: ScoreboardLoopPlayer,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/scoreboard/tv-board-preview/:boardId',
		name: 'ScoreboardBoardPreview',
		component: () => import('@/modules/scoreboard/views/ScoreboardBoardPreview.vue'),
		meta: {
			requiresAuth: true,
		},
	},
	// Chrome-less single-board capture for Puppet / Slack screenshots.
	// requiresAuth:false — API still gated by Sanctum via _token cookie.
	{
		path: '/scoreboard/loop/:loopId/board/:boardId/position/:position/render',
		name: 'ScoreboardBoardRender',
		component: () => import('@/modules/scoreboard/views/ScoreboardBoardRender.vue'),
		meta: {
			requiresAuth: false,
		},
	},
];


export default routes;
